// api/BaseApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";

const base_url = process.env.REACT_APP_BASE_API_URL || "https://api.saef.app";

export const baseApi = createApi({
  reducerPath: "baseApi",
  tagTypes: [
    "AdminJobsSummary",
    "CompanyEmployees",
    "AdminCompanies",
    "JobDetails",
    "AdminUserDetails",
    "User",
    "Affiliates",
    "ProductDetails",
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: base_url,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).root.sessionState.user?.idToken;
      const accessToken = (getState() as RootState).root.sessionState.user
        ?.accessToken;
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
        headers.set("X-Saef-Access-Token", accessToken);
      }

      return headers;
    },
  }),
  endpoints: () => ({}), // Define an empty endpoints object
});
